/**
 * Tutor No-Show Management System
 *
 * A clean, state-machine based approach to handle tutor absence in live sessions
 *
 * Usage:
 * 1. Wrap your live session component tree with TutorNoShowProvider
 * 2. Use useTutorNoShow hook in child components to access state
 * 3. Render UI components (WaitingBanner, RecoveryModal, CreditModal, InitialDialog)
 */

export { TutorNoShowProvider, useTutorNoShow } from './TutorNoShowContext'
export { useTutorNoShowMachine } from '../../../../engine/live/student/tutorNoShow/useTutorNoShowMachine'
export { TUTOR_NO_SHOW } from '../../../../engine/live/student/tutorNoShow/constants'

// UI Components
export { WaitingBanner } from './components/WaitingBanner'
export { RecoveryModal } from './components/RecoveryModal'
export { CreditModal } from './components/CreditModal'
export { InitialDialog } from './components/InitialDialog'
export { CountdownTimer } from './components/CountdownTimer'
export { MiniModeWaitingBar } from './components/MiniModeWaitingBar'
